var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card-group',{attrs:{"grid":""}},_vm._l((_vm.items),function(item,idx){return _c('b-card',{key:idx,style:({'max-width': '150px', 'min-width': '150px', 'margin': '5px'}),attrs:{"no-body":""}},[_c('Six',{attrs:{"viewdata":item}})],1)}),1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f988b0f","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminTools/AdminToolsStorePickups.vue
// module id = null
// module chunks = 